// import images from "./images";

let Experience = [
  {
    year: 2022,
    works: [
      {
        workId: 1,
        name: "Trainee - Associate Software Engineer",
        company: "IDeaS Revenue Solutions",
        description:
          "Successfully created a stable path for MySQL database upgrade for IDeaS G2-Casper and IDeaS G2-Classic applications which provides Revenue Management for 10000+ hotels across the world. Major Improvement done : Latency optimisation for slow SQL queries from 240s to 1.2s. Completely Automated multiple API testing by creating and optimizing Postman tests for IDeaS's G2-Casper spring boot application.",
      },
    ],
  },
];

export default Experience;
